import React from 'react'
import { authService } from '../auth';
import axios from "axios";
import OtpInput from "react-otp-input";
import FooterDiv from "../FooterDiv";
import httpService from '../AxiosInterceptors';
import { withRouter } from 'react-router-dom';
import { userAgentPostData } from '../commons/CommonFunctions';

httpService.setupInterceptors();

class OtpVerify extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            messages: null,
            isLoading: true,
            loginSuccess: authService.isAuthenticated(),
            userData: authService.getUserDetailsFromLocalStorage(),
            signUpSuccess: false,
            emailAvailable: false,
            otp: '',
            numInputs: 6,
            separator: '',
            isDisabled: false,
            hasErrored: false,
            isInputNum: true,
            data: props.location?.state?.signUpResponse,
            resendOTP: false,
            message: '',
            success: false,
            textOtp: '',
            minutes: 10,
            seconds: 0,
            resendMinutes: 2,
            resendSeconds: 0,
            showResendButton: props.location?.state?.signUpResponse?.emailResend,
            resendEmailFireCount: 0,
            emailErrorMessage: "",
            updatedEmail: "",
            errors: {}
        };
    }

    handleOtpChange = otp => {
        this.setState({ otp });
    };

    getMobileOperatingSystem() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }
        if (/android/i.test(userAgent)) {
            return "Android";
        }
        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }
        return "unknown";
    }

    componentDidMount() {
        let os = this.getMobileOperatingSystem()
        if (os !== 'iOS') {
            window.$(".OTP").keydown(function (event) {
                // Allow only backspace and delete
                if (event.keyCode == 46 || event.keyCode == 8) {
                    // let it happen, don't do anything
                }
                else {
                    // Ensure that it is a number and stop the keypress
                    if ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
                        event.preventDefault();
                    }
                }
            });
        }
        if (this.props?.location?.state?.signUpResponse) {
            this.setState({
                data: this.props?.location?.state?.signUpResponse
            })
        } else {
            this.props.history.push({
                pathname: "/"
            })
        }
        this.resendButtonWait();
        this.resndEmailOtpButtonWait();

        // google otp conversion
        // {
        //     process.env.REACT_APP_environment === 'prod' && window.gtag('config', 'AW-713421902')
        //     process.env.REACT_APP_environment === 'prod' && window.gtag('event', 'conversion', {'send_to': 'AW-713421902/Zj2ICOmrx_QCEM7ol9QC'});
        // }

    }

    componentWillUnmount() {
        clearInterval(this.myInterval);
        clearInterval(this.resndEmailOtpInterval);
    }

    validate(evt) {
        var theEvent = evt;

        // Handle paste
        if (theEvent.type === 'paste') {
            key = theEvent.clipboardData.getData('text/plain');
        } else {
            // Handle key press
            var key = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(key);
        }
        var regex = /[0-9]|\./;
        if (!regex.test(key)) {
            theEvent.returnValue = false;
            if (theEvent.preventDefault) theEvent.preventDefault();
        }
    }

    resendButtonWait = () => {
        this.myInterval = setInterval(() => {
            const { seconds, minutes } = this.state

            if (seconds > 0) {
                this.setState(({ seconds }) => ({
                    seconds: seconds - 1
                }))
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(this.myInterval)
                } else {
                    this.setState(({ minutes }) => ({
                        minutes: minutes - 1,
                        seconds: 59
                    }))
                }
            }
        }, 1000)
    }

    resndEmailOtpButtonWait = () => {
        this.resndEmailOtpInterval = setInterval(() => {
            const { resendSeconds, resendMinutes } = this.state

            if (resendSeconds > 0) {
                this.setState(({ resendSeconds }) => ({
                    resendSeconds: resendSeconds - 1
                }))
            }
            if (resendSeconds === 0) {
                if (resendMinutes === 0) {
                    clearInterval(this.resndEmailOtpInterval)
                } else {
                    this.setState(({ resendMinutes }) => ({
                        resendMinutes: resendMinutes - 1,
                        resendSeconds: 59
                    }))
                }
            }
        }, 1000)
    }

    handleSubmit = (event) => {
        event.preventDefault();
        let postBody = {
            "userId": this.state.data?.userId,
            "transactionId": this.state.data?.transactionId,
            "otp": this.state?.otp
        };
        axios({
            method: 'post',
            url: `${process.env.REACT_APP_userServiceURL}/otp/signup/verify`,
            headers: { 'Content-Type': 'application/json' },
            data: postBody,
            withCredentials: true
        }).then((response) => {
            let res = response.data;
            if (res.message === 'Success!') {
                let userData = authService.getUserDetailsFromLocalStorage();
                if (userData) {
                    userData.phone = res.body.mobile;
                    userData.email = res.body.email;
                    authService.updateUserData(userData);
                }
                if (this.state.userData.type === 'INDIVIDUAL') {
                    // this.props.history.push({
                    //     pathname: '/address',
                    //     state: {
                    //         signUpResponse: this.state.data
                    //     }
                    // })
                    this.props.history.push({
                        pathname: '/personal',
                        state: {
                            signUpResponse: this.state.data
                        }
                    })
                } else {
                    if (res.body.profileInfoUpdated) {
                        userData.userDataPending = false;
                        authService.updateUserData(userData);
                        window.location.href = "/";
                    } else {
                        this.props.history.push({
                            pathname: '/companyprofile'
                        })
                    }
                }
            }
        }).catch((err) => {
            if (err && err.response && err.response.data) {
                setTimeout(() => {
                    this.revokeError();
                }, 5000);
                this.setState({
                    isLoaded: true,
                    error: { message: err.response.data.message, err: err.response }
                });
            }
            this.clearOtp();
        });
    };

    emailResendRequest = (event) => {
        event.preventDefault();
        let postBody = {
            "transactionId": this.state?.data?.transactionId
        };
        axios({
            method: 'post',
            url: `${process.env.REACT_APP_userServiceURL}/email/resend`,
            headers: { 'Content-Type': 'application/json' },
            data: postBody
        }).then((response) => {
            if (response.data?.message === 'Success!') {
                this.setState({ showResendButton: false, resendEmailFireCount: this.state?.resendEmailFireCount + 1, resendMinutes: 2, resendSeconds: 0 });
                this.clearOtp();
                window.$("#emailSentSuccessPopUp").modal("show");
                this.resndEmailOtpButtonWait();
            }
        }).catch((err) => {
            if (err && err.response) {
                this.setState({
                    emailErrorMessage: err.response?.data?.message
                });
            }
            setTimeout(() => {
                this.setState({
                    emailErrorMessage: ''
                });
            }, 5000);
            console.log(err);
        });
    };

    resendOtp = (event) => {
        event.preventDefault();
        this.setState({ resendOTP: false });
        let postBody = {
            "userId": this.state.data.userId,
            "otpType": 'SIGNUPRESEND'
        };
        axios({
            method: 'post',
            url: process.env.REACT_APP_userServiceURL + '/otp/send',
            headers: { 'Content-Type': 'application/json' },
            data: postBody,
            withCredentials: true
        }).then((response) => {
            let res = response.data;
            if (res.message === 'Success!') {
                if (this.state.data) {
                    this.state.data.transactionId = res.body.transactionId;
                }
                this.setState({ message: 'OTP resent successfully', minutes: 10, seconds: 0, resendMinutes: 2, resendSeconds: 0 });
                this.setState({ success: true });
                this.setState({ resendOTP: false });
                this.resendButtonWait();
                this.resndEmailOtpButtonWait()
                setTimeout(() => {
                    this.setState({ message: '' });
                    this.setState({ success: false });
                    this.resendButtonWait();
                }, 5000);
            }
        }).catch((err) => {
            console.log(err);
            if (err && err.response && err.response.data) {
                this.setState({
                    isLoaded: true,
                    resendOTP: true,
                    error: { message: err.response.data.message, err: err.response }
                });
            }
        });
    };

    clearOtp = () => {
        this.setState({ otp: '' });
    };

    onHideModal = () => {
        this.setState({
            updatedEmail: ''
        })
        window.$("#editEmailIDPop").modal("hide");
    }

    revokeError() {
        this.setState({ messages: '' });
        this.setState({ error: false });
    }

    validateForm() {
        let errors = {};
        let formIsValid = true;
        if (!this.state.updatedEmail) {
            errors["updatedEmail"] = "Please enter your email address";
            formIsValid = false;
        } else {
            const newEmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!newEmailRegex.test(this.state.updatedEmail)) {
                errors["updatedEmail"] = "Please enter a valid email address";
                formIsValid = false;
            }
        }
        this.setState({
            errors: errors
        });
        return formIsValid;
    }

    emailChangeRequest = (event) => {
        event.preventDefault();
        if (this.validateForm()) {
            let postBody = {
                "userId": this.state.data?.userId,
                "existingEmailId": this.state.data?.email,
                "newEmailId": this.state.updatedEmail,
                "userAgent": userAgentPostData()
            };
            axios({
                method: 'post',
                url: `${process.env.REACT_APP_userServiceURL}/profile/update/email-id`,
                headers: { 'Content-Type': 'application/json' },
                data: postBody
            }).then((response) => {
                if (response?.data?.message === "Success!") {
                    this.setState(
                        (prevState) => ({ data: { ...prevState.data, email: this.state.updatedEmail } })
                    );
                }
                this.onHideModal();
            }).catch((err) => {
                if (err && err.response) {
                    this.setState(
                        (prevState) => ({ errors: { ...prevState.errors, ["updatedEmail"]: err.response.data.message } })
                    );
                }
                setTimeout(() => {
                    this.setState(
                        (prevState) => ({ errors: { ...prevState.errors, ["updatedEmail"]: "" } })
                    );
                }, 5000);
            });
        }
        setTimeout(() => {
            this.setState(
                (prevState) => ({ errors: { ...prevState.errors, ["updatedEmail"]: "" } })
            );
        }, 5000);
    };

    render() {
        const { otp, numInputs, separator, isDisabled, hasErrored, minutes, seconds, showResendButton, emailErrorMessage, resendEmailFireCount, resendMinutes, resendSeconds, updatedEmail, errors } = this.state;
        return <section className="signup-wrapper">
            <div className="signup-container pt-3">
                <a href="/login" className="goback"> Go Back</a>
                <div className="signup-box text-center">
                    <div className="signup-boxinn otpwrap">
                        <a href="/"><img src="https://cdn.dscovr.com/images/logoWeNaturalists.svg" alt="" className="logotop" /></a>
                        <h1 className="signup-header-text">Authentication</h1>
                        <div className='otpNewText'>
                            <p>Enter the 6-digit OTP sent on your {this.state?.data?.email ? 'email' : 'mobile'}, <span>{this.state?.data?.email}</span><a href="#editEmailIDPop" data-toggle="modal" ><i class="iEditBox"></i></a></p>
                            {(minutes > 0 || seconds > 0) && 
                                (resendEmailFireCount < 3 ?
                                    <p>Did not receive an email? {resendMinutes === 0 && resendSeconds === 0 ? <a href="javascript:void(0)" onClick={this.emailResendRequest} className="clickTxt">Resend</a> : <span className='disabled'>Resend</span>}  {resendMinutes === 0 && resendSeconds === 0 ? "" : `in ${resendMinutes + ' min '}:${' ' + resendSeconds < 10 ? `0${resendSeconds} sec` : ' ' + resendSeconds + ' sec'}`}</p> :
                                    <p>If you have still not received an email, please connect with us at <a href='mailto:support@wenaturalists.com' style={{ color: "#bfc52e" }}>support@wenaturalists.com</a></p>
                                    // (resendMinutes === 0 && resendSeconds === 0 ?
                                    //     <p>If you didn't receive email Please <a href="javascript:void(0)" onClick={this.emailResendRequest} className="clickTxt">click here</a> to resend</p> :
                                    //     <p>You can resend email after {resendMinutes + ' min '}:{" " + (resendSeconds < 10 ? "0" : "") + seconds + ' sec'}</p>
                                    // )
                                )
                            }
                            <p>Check spam or recheck entered email id if you still haven’t received an email</p>
                            {emailErrorMessage &&
                                <span className="login-feedback-error mt-1" style={{ display: "block" }}>
                                    {emailErrorMessage}
                                </span>
                            }
                        </div>
                        <div className="signup-form-container">
                            <form className="otp-form" onSubmit={this.handleSubmit}>
                                <div className="optfield">
                                    <OtpInput
                                        numInputs={numInputs}
                                        isDisabled={isDisabled}
                                        hasErrored={hasErrored}
                                        errorStyle="error"
                                        onChange={this.handleOtpChange}
                                        onkeypress={this.validate}
                                        inputStyle="OTP"
                                        separator={<span>{separator}</span>}
                                        pattern='[0-9]{0,5}'
                                        shouldAutoFocus
                                        value={otp}
                                    />
                                    {this.state.error &&
                                        <div className="login-feedback-error">
                                            <strong></strong> {this.state.error.message}.
                                        </div>
                                    }
                                </div>
                                <div>
                                    <button className="login-btn btn btn-primary mt-3" disabled={otp.length < numInputs}>
                                        Submit
                                    </button>
                                    <p className="resend">
                                        {minutes === 0 && seconds === 0 ?
                                            // <button type="button" onClick={this.resendOtp} className="counter_Btn btn mt-1">Resend</button>
                                            <p>If you have still not received an email, please connect with us at <a href='mailto:support@wenaturalists.com' style={{ color: "#bfc52e" }}>support@wenaturalists.com</a></p>
                                            : <h1>OTP will expire in {" "} {minutes + ' min '}:{' ' + seconds < 10 ? `0${seconds} sec` : ' ' + seconds + ' sec'}</h1>
                                        }
                                        {this.state.success && this.state.message}
                                    </p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                {/* Edit Email Id pop up */}
                <div id="editEmailIDPop" className="modal fade dgpopup editEmailPop" tabIndex="-1"
                    data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="similarAllpopWrap forwcontwrap"
                                    style={{ maxWidth: "460px", position: 'relative' }}>
                                    <button type="button" className="close topCrossModal" data-dismiss="modal"
                                        aria-label="Close" onClick={(e) => this.onHideModal()}
                                        style={{ top: '13px' }}>
                                        <i className="iCross" />
                                    </button>
                                    <div className="similarAllpopHeader">
                                        <h2>Edit Email Id</h2>
                                    </div>
                                    <div className="similarAllpopBody">
                                        <div>
                                            <div className="form-group">
                                                <input id="newEmail" type="text" onChange={(e) => {this.setState({ updatedEmail: e.target.value.trim() });}} className="form-control custom-input" placeholder="Enter Email" value={updatedEmail} />
                                                {errors["updatedEmail"] &&
                                                    <span className="login-feedback-error mt-1" style={{ display: "block" }}>
                                                        {errors["updatedEmail"]}
                                                    </span>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="forwcontwrapbott justify-content-end">
                                        <div>
                                            <button className="btn" type="submit" onClick={this.emailChangeRequest} style={{ marginRight: '5px', padding: '9px 15px' }}>Submit</button>
                                            <button className="butt btnsecondary close"
                                                data-dismiss="modal" onClick={(e) => this.onHideModal()}>Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Email Resnd success pop up */}

                <div id="emailSentSuccessPopUp" className="modal fade dgpopup confirmpop" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { window.$("#emailSentSuccessPopUp").modal("hide") }}>
                                <span aria-hidden="true">&times;</span></button>
                            <div className="confirm-popup-modal-body">
                                Email has been sent Successfully
                            </div>
                            <div className="modal-footer confirm-popup-modal-footer">
                                <button className="confirm-pop-btn-secondary" data-dismiss="modal" onClick={(e) => { window.$("#emailSentSuccessPopUp").modal("hide") }}>Ok</button>
                            </div>
                        </div>
                    </div>
                </div>

                <FooterDiv />
            </div>
        </section>
    }
}

export default withRouter(OtpVerify);
